import * as React from 'react';

import { getContextCoverageByContextPrice } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { ClicksByPriceData } from '../../typings/domain';
import { NumberCell } from '../NumberCell/NumberCell';

interface PhraseContextCoverageCellProps {
    allCostsAndClicks: Array<ClicksByPriceData>;
    maxShows: number;
    priceContext: number;
}

export class PhraseContextCoverageCell extends React.PureComponent<
    PhraseContextCoverageCellProps
> {
    render() {
        return <NumberCell num={this.getCoverage()} fractionalPartLength={0} />;
    }

    private getCoverage = () => {
        const { priceContext, maxShows, allCostsAndClicks } = this.props;

        return getContextCoverageByContextPrice(
            priceContext,
            allCostsAndClicks,
            maxShows
        );
    };
}
